import { render, staticRenderFns } from "./ProgramActivityUpdate.vue?vue&type=template&id=2710d880&scoped=true"
import script from "./ProgramActivityUpdate.vue?vue&type=script&lang=js"
export * from "./ProgramActivityUpdate.vue?vue&type=script&lang=js"
import style0 from "./ProgramActivityUpdate.vue?vue&type=style&index=0&id=2710d880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710d880",
  null
  
)

export default component.exports